/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EntityStatus } from './entityStatus';


export interface ServiceproviderDto { 
    serviceProviderId?: string;
    serviceProviderName?: string;
    accountEmail?: string;
    authenticationId?: string;
    contactPersonFirstName?: string;
    contactPersonLastName?: string;
    contactPersonEmail?: string;
    applicationId?: string;
    status: EntityStatus;
    contactPersonPhoneNumber?: string;
    vasLicenseId?: string;
    vasLicenseActiveDate?: Date;
    vasLicenseExpiryDate?: Date;
    approved?: string;
    declineReason?: string;
}
